import { jsx } from "react/jsx-runtime";
import MicIcon from "@mui/icons-material/Mic";
import { validateTidalLicense } from "../../base/index.js";
function Mic(props) {
  return /* @__PURE__ */ jsx(
    MicIcon,
    {
      "data-testid": "Mic",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Mic",
      "data-tidal-icon-meta": "chat,customerService"
    }
  );
}
Mic.tidalIconMeta = {
  categories: "chat,customerService",
  name: "Mic"
};
validateTidalLicense();
export {
  Mic
};
//# sourceMappingURL=Mic.js.map
